import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AttributeUtility } from '../../../Service/AttributeUtility';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class TensionControllerRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr="A_PIM_Bild_Basisartikel"/></td>
            <AttributeCell product={product} attr="Beschreibung_Basisartikel_kurz"/>
            <AttributeCell product={product} attr="@parent.Kundennutzen"/>
            <AttributeCell product={product} extra={true} attr="@parent.Feldbus"/>
            <AttributeCell product={product} extra={true} attr="Schutzart"/>
            <AttributeCell product={product} extra={true} attr="@parent.Anzahl_Kanaele"/>
            <AttributeCell product={product} extra={true} attr="@parent.Anzahl_Kraftaufnehmer"/>
            <AttributeCell product={product} extra={true} attr="output">
                <ul className="pf-mini-list">{this.collectAnalogOutputs(product).map(o => <li key={o}>{o}</li>)}</ul>
            </AttributeCell>
            <MiscCell product={product} datasheetAttr="@parent.Datenblatt" manualAttr="@parent.Bedienungsanleitung"/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={3} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }

    private collectAnalogOutputs(product: ProductInterface): string[] {
        const currentOutput = AttributeUtility.attributeForKey(product.parent, 'Stromausgang');
        const voltageOutput = AttributeUtility.attributeForKey(product.parent, 'Spannungsausgang');

        return [
            currentOutput ? currentOutput.displayString : '',
            voltageOutput ? voltageOutput.displayString : ''
        ].filter(v => !!v);
    }
}
